import { AllowedFormData, createFormData, ensureFormHeader } from '../utils/form';
import { api, ApiRequest, ApiResponse } from '../instance';

export const postRaw = api.post;

export async function postFormRaw<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config: ApiRequest = {},
): Promise<ApiResponse<T>> {
  const postData = formData ? createFormData(formData) : undefined;
  const fullConfig = formData ? ensureFormHeader(config) : config;

  return postRaw<T>(url, postData, fullConfig);
}

export async function post<T = any>(
  url: string,
  postData?: any,
  config: ApiRequest = {},
): Promise<T> {
  return (await postRaw<T>(url, postData, config)).data;
}

export async function postForm<T = any>(
  url: string,
  formData?: FormData | Record<string, AllowedFormData>,
  config: ApiRequest = {},
): Promise<T> {
  return (await postFormRaw<T>(url, formData, config)).data;
}
